import { useSuspenseQuery } from '@apollo/client';
import { useIntl } from 'react-intl';

import { GenericError, Head } from '@xing-com/crate-career-hub-common';
import { CareerHubGlossaryDocument } from '@xing-com/crate-career-hub-glossary-graphql';
import { LoggedOutFooter } from '@xing-com/crate-career-hub-logged-out-footer';
import { ErrorBoundary } from '@xing-com/crate-core-error-boundary';
import { NoSSRLoggedInSuspense } from '@xing-com/crate-utils-no-ssr';
import { Section, Container } from '@xing-com/layout-primitives';

import { ArticleList, ArticleListSkeleton } from '../article-list';
import { GlossaryHeader } from '../glossary-header';
import { HeaderNavigation } from '../header-navigation';

export const GlossaryContentInner: React.FC = () => {
  const { data } = useSuspenseQuery(CareerHubGlossaryDocument);

  const articlesCollection = data.careerHubGlossary?.collection;

  const reducedLetters: { [letter: string]: boolean } = {};
  for (const collection of articlesCollection || []) {
    if (collection?.letter && collection?.articles.length > 0) {
      reducedLetters[collection.letter] = true;
    }
  }

  return (
    <>
      <ArticleList {...{ articlesCollection, reducedLetters }} />
      <LoggedOutFooter {...{ reducedLetters }} openInSameTab />
    </>
  );
};

export const GlossaryContent: React.FC = () => {
  const { formatMessage } = useIntl();

  return (
    <Section noBlockPadding>
      <Container>
        <Head />
        <HeaderNavigation
          title={formatMessage({ id: 'CAREER_HUB_GLOSSARY_PAGE_TITLE' })}
        />
        <GlossaryHeader />
        <ErrorBoundary
          onError={() => (
            <>
              <GenericError refetch={() => window.location.reload()} />
              <LoggedOutFooter openInSameTab />
            </>
          )}
        >
          <NoSSRLoggedInSuspense
            fallback={
              <>
                <ArticleListSkeleton />
                <LoggedOutFooter openInSameTab />
              </>
            }
          >
            <GlossaryContentInner />
          </NoSSRLoggedInSuspense>
        </ErrorBoundary>
      </Container>
    </Section>
  );
};
